<form (ngSubmit)="signInWithOtp()">
  <button class="login-button otp">
    <p style="margin-bottom: 8px">ENTER LOGIN CODE</p>
    <span id="login-otp" (click)="$event.preventDefault()">
      <input
        type="password"
        name="login-otp"
        autocomplete="one-time-code"
        #loginOtp
        placeholder="Paste login code here"
        (input)="onInput(loginOtp.value)"
        (paste)="onPasteLoginOtp($event, loginOtp)"
        />
        <mat-icon
          class="paste-icon"
          fontIcon="content_paste_go"
          title="Paste login code"
          tabindex="0"
          (click)="pasteOtpAndLogin()"
          (keydown.space)="pasteOtpAndLogin($event)"
          (keydown.enter)="pasteOtpAndLogin($event)"
        ></mat-icon>
        @if (showClearIcon) {
          <mat-icon
            class="clear-icon"
            fontIcon="clear"
            (click)="clearInput(loginOtp)"
            (keydown.space)="clearInput(loginOtp, $event)"
            (keydown.enter)="clearInput(loginOtp, $event)"
            title="Clear text"
            tabindex="0"
          ></mat-icon>
        }
      </span>
    </button>
  </form>

  @if (!showPasswordSignIn()) {
    <p class="login-code-note">
      To generate a Login Code, sign into the
      <strong
        ><a class="manager-link" [href]="managerUrl" target="_blank" rel="noopener noreferrer"
          >Template Manager<mat-icon class="external-link-icon" fontIcon="open_in_new" title="Opens in your browser"></mat-icon></a></strong
      >. Then open the menu (top-left) and click <strong>Generate login code</strong>.
    </p>
  }

  @if (showPasswordSignIn()) {
    <button class="login-button bullhorn" (click)="signInWithBullhorn()">
      Sign in with Bullhorn
      @if (loginSpinner.bullhorn) {
        <span class="loading-spinner spinner-border spinner-border-sm"></span>
      }
    </button>
    <div class="salesforce-login">
      <button class="login-button salesforce" (click)="signInWithSalesforce()">
        Sign in with Salesforce
        @if (loginSpinner.salesforce) {
          <span class="loading-spinner spinner-border spinner-border-sm"></span>
        }
      </button>
      <mat-slide-toggle class="sandbox-toggle" color="primary" [(ngModel)]="useSalesforceSandbox">Sandbox</mat-slide-toggle>
    </div>
    <form (ngSubmit)="signInWithInvenias(tenantName.value)">
      <button class="login-button invenias">
        Sign in with Invenias
        @if (loginSpinner.invenias) {
          <span class="loading-spinner spinner-border spinner-border-sm"></span>
        }
        <div class="tenant-container" (click)="$event.preventDefault()">
          <span>Tenant</span>
          <span id="tenant-login">
            <input type="text" name="tenant" placeholder="e.g. Kyloe" value="{{ lastUsedTenant }}" #tenantName />
            @if (tenantName.value) {
              <mat-icon
                class="clear-icon"
                fontIcon="clear"
                (click)="clearInput(tenantName)"
                (keydown.space)="clearInput(tenantName, $event)"
                (keydown.enter)="clearInput(tenantName, $event)"
                title="Clear text"
                tabindex="0"
              ></mat-icon>
            }
          </span>
        </div>
      </button>
    </form>
    <h5 class="login-window-note">
      If you accidentally close the login window, please close and reopen this task pane to try again.
    </h5>
  }
